import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { ROLES } from '@sime/shared';
import { useAuthStore } from '@/stores/auth.store';

// LIDER must land in /l regardless of how the AppShell was reached
// (PWA shortcut, refresh with persisted session, deep link, manual URL).
// The login form already redirects to /l on submit; this catches every
// other path that bypasses the form.
export function LiderGuard({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (user?.tipoUsuarioId === ROLES.LIDER) {
    return <Navigate to="/l" replace />;
  }
  return <>{children}</>;
}
